import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<App />);
} else {
  console.error('Root element not found!');
}

// Makes the site installable and lets already-visited pages load offline.
// A tenant on an old cached version is asked once to refresh, so a deploy
// (e.g. a bug fix) doesn't leave them stuck -- never applied silently
// mid-session, which could interrupt something they're doing.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (window.confirm('A new version of this app is available. Refresh now?')) {
      if (registration.waiting) registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
  },
});
